import React from 'react';
import { financeFormat } from '@sg/utils/common';
import type { TMetricScope } from '../../utils/normalizeMetricAxisRows';

export const getStaffRateColumns = (scope: TMetricScope = 'studio') => [
  {
    header: scope === 'portfolio' ? 'Studio' : 'Date',
    // Portfolio keeps API `date` for tooltips; table first column reads `label`.
    dataIndex: scope === 'portfolio' ? 'label' : 'date',
    key: scope === 'portfolio' ? 'label' : 'date',
    width: scope === 'portfolio' ? 140 : 70,
  },
  {
    header: (
      <div style={{ textAlign: 'right', textWrap: 'nowrap', paddingRight: '20px' }}>
        Staff Rate
      </div>
    ),
    title: 'Staff Rate',
    dataIndex: 'staff_rate',
    key: 'staff_rate',
    width: 120,
    format: (val: number) => financeFormat(val, 1),
    render: (item: any) => (
      <div style={{ textAlign: 'right', textWrap: 'nowrap', paddingRight: '20px' }}>
        {item?.staff_rate !== null && item?.staff_rate !== undefined
          ? financeFormat(item.staff_rate, 1)
          : 'NA'}
      </div>
    ),
  },
];
